import React, { useState, useEffect } from 'react'

import './liveAuction.css'
import EndingSoon from '../Homepage/EndingSoon'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom/cjs/react-router-dom'
import { use } from 'react'
import { isAuthenticated } from '../../Utils/Auth'
import PrimaryButton from '../../components/atoms/PrimaryButton'

const LiveAuction = () => {
    const searchText = new URLSearchParams(window.location.search).get('search')
    const [filterData, setFilterData] = useState({
        make: '',
        model: '',
        transmission: '',
        orderby: 6,
        searchbar: searchText,
    })
    const location = useLocation()

    useEffect(() => {
        const search = new URLSearchParams(location.search).get('search')

        setFilterData((prev) => ({ ...prev, searchbar: search }))
    }, [location.search])

    const { t } = useTranslation()
    const [searchTrigger, setSearchTrigger] = useState(false)
    const handleFilterChange = (e) => {
        const { name, value } = e.target
        setFilterData({ ...filterData, [name]: value })
    }

    return (
        <div className="live-auction customContainer pt-5 position-relative">
            {!isAuthenticated() ? (
                <div className="stkyContent">
                    <div className="textConte">
                        <h4 className="mb-3">
                            {t('want_to_view')} <span className="auction">{t('auctions')}?</span>
                        </h4>
                        <p className="mb-0">
                            <PrimaryButton
                                customClassName="buttonClass"
                                onClick={() => history.push('/login')}
                            >
                                {t('login_upper')}/{t('register')}
                            </PrimaryButton>
                        </p>
                    </div>
                </div>
            ) : null}
            <div className={isAuthenticated() ? '' : 'changeBlur'}>
                <EndingSoon
                    filterData={filterData}
                    searchTrigger={searchTrigger}
                    setSearchTrigger={setSearchTrigger}
                    handleFilterChange={handleFilterChange}
                    heading={t('live_auction')}
                    page={true}
                    className={'live-auction-productGrid productGrid'}
                />
            </div>
        </div>
    )
}

export default LiveAuction
